module.exports = __webpack_public_path__ + "static/media/aaib.508ea0dc.png";